// extracted by mini-css-extract-plugin
export default {"appIllustrationContainer":"ClientApp--appIllustrationContainer--3e20f1","appvocacyContainer":"ClientApp--appvocacyContainer--2d1659"};